var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "approve"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5429 16.4571L11.75 14.6642L13.1642 13.25L14.25 14.3358L21.7929 6.79289C22.1834 6.40237 22.8166 6.40237 23.2071 6.79289C23.5976 7.18342 23.5976 7.81658 23.2071 8.20711L14.9571 16.4571C14.5666 16.8476 13.9334 16.8476 13.5429 16.4571ZM15.7071 8.20711C16.0976 7.81658 16.0976 7.18342 15.7071 6.79289C15.3166 6.40237 14.6834 6.40237 14.2929 6.79289L6.75 14.3358L3.70711 11.2929C3.31658 10.9024 2.68342 10.9024 2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071L6.04289 16.4571C6.43342 16.8476 7.06658 16.8476 7.45711 16.4571L15.7071 8.20711Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.4c9ecfd766121ac9bb036ba33958dfa0.svg";
export { ForwardRef as ReactComponent };